const errorCode = new Map()
errorCode.set(1003, 'userUnvisitable')
errorCode.set(1004, 'userUnAuth')
errorCode.set(1005, 'companyUnAuth')

export default errorCode
